import Event from '@oppobrowser/lib-browser-event';
import template from './index.dot';
import { $ } from '@js/utils';

import './index.scss';
import { stat_id } from '../../js/constants';
import { weatherBizTracReport } from '@js/native';

const EventHandler = {};

export default class VideoPlayer {
  constructor(el, name, data = {}) {
    this.el = el;
    this.data = data;
    this._eventHandler = {};
  }

  init() {
    Object.keys(EventHandler).forEach((fn) => {
      this._eventHandler[fn] = EventHandler[fn].bind(this);
    });
    this._bindEvent();
  }

  _bindEvent() {
    this._comEvent = new Event('click', this.el);
    this._comEvent.registeHandler(this._eventHandler);
  }

  registerPlayEvent() {
    let play = $('.icon-play');
    let video = $('.video-content');
    play.addEventListener(
      'click',
      () => {
        video.play();
        play.style['display'] = 'none';
        video.classList.add('play-height');
        $('.video-cover').style['display'] = 'none';
      },
      false,
    );
  }
  registerStat() {
    this._videoEl = $('.video-content');
    //获取到视频的播放数据之后，监听页面离开的时候上报视频播放时长
    this._videoEl.addEventListener('loadeddata', () => {
      if (typeof document.visibilityState != 'undefined') {
        document.addEventListener('visibilitychange', handleVisibilityChange);
      } else if (typeof document.webkitVisibilityState != 'undefined') {
        document.addEventListener(
          'webkitvisibilitychange',
          handleVisibilityChange,
        );
      }
    });
  }
  render() {
    const { coverUrl, videoInfo } = window.store;
    this.el.innerHTML = template({
      coverUrl,
      videoInfo,
    });
    this.registerPlayEvent();
    this.registerStat();
  }
}
function handleVisibilityChange() {
  if (document.visibilityState == 'visible') return;
  // console.log('in video stat',this._videoEl);
  const videoContent = $('.video-content');
  if (!videoContent) return;
  const { duration, currentTime } = videoContent;

  // 上报天气信息流归因参数
  let bizTraceInfo = weatherBizTracReport();

  const data = {
    viewTime: currentTime,
    percent: ((currentTime / duration) * 100).toFixed(1),
    totalTime: duration,
    newsSource: 'detailPage',
    stat_id: stat_id,
    ...bizTraceInfo,
  };
  wv?.statVideoPlayingDuration(data);
  // ? wv.statVideoPlayingDuration(data)
  // : window.wv.generalStat(20083207, 105301, 10012, JSON.stringify(data));
}
